import { ApiClient } from './apiClient';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export interface OrderWithLinesDto {
  header: OrderDto;
  lines: OrderLineDto[];
}

export interface UpdateOrderRequest {
  orderStatusERP?: string;
  deliveryDate?: string;
  arrivalDate?: string;
  deliveryMethod?: string | null;
  deliveryMethodNo?: number | null;
  carrierName?: string | null;
  delCustomerName?: string;
  delAddress1?: string;
  delAddress2?: string;
  delAddress3?: string;
  delZipCode?: string;
  delCity?: string;
  delCountryCode?: string;
  contactName?: string;
  eMailAddress?: string;
  ourRef?: string;
  projectNo?: string;
  depNo?: string;
  district?: string;
  districtNo?: number;
  filterGroupID?: string;
  orderPriority?: number;
  customerPriority?: number;
  orderTotal?: number;
  orderFreeField1?: string;
  orderFreeField2?: string;
  orderFreeField3?: string;
  orderFreeField4?: string;
  orderFreeField5?: string;
  orderFreeField6?: string;
  orderFreeField7?: string;
  orderFreeField8?: string;
  orderFreeField9?: string;
  orderFreeField10?: string;
  orderFreeField11?: string;
  orderFreeField12?: string;
  orderFreeField13?: string;
  orderFreeField14?: string;
  orderFreeField15?: string;
  orderFreeField16?: string;
  pListFreeField1?: string;
  pListFreeField2?: string;
  pListFreeField3?: string;
  formNoPackingslip?: number;
  formNoInvoice?: number;
}

export interface UpdateOrderLineRequest {
  weight?: number;
  height?: number;
  length?: number;
  width?: number;
  volum?: number;
  orderLineFreeField1?: string;
  orderLineFreeField2?: string;
  orderLineFreeField3?: string;
  orderLineFreeField4?: string;
  orderLineFreeField5?: string;
  orderLineFreeField6?: string;
  orderLineFreeField7?: string;
  orderLineFreeField8?: string;
  orderLineFreeField9?: string;
  orderLineFreeField10?: string;
}

export interface OrderDto {
  id: number;
  companyNo: string;
  orderNo: number;
  orderNoERP: string;
  orderStatus: number;
  pickListNoERP?: string;
  orderType?: string;
  orderStatusERP?: string;
  orderDate?: string;
  deliveryDate?: string;
  customerNo: string;
  customerName?: string;
  delAddressNo?: number;
  delCustomerName?: string;
  delAddress1?: string;
  delAddress2?: string;
  delAddress3?: string;
  delZipCode?: string;
  delCity?: string;
  delCountryCode?: string;
  delCountryName?: string;
  deliveryGLN?: string;
  customerOrderNo?: string;
  yourRef?: string;
  ourRef?: string;
  projectNo?: string;
  depNo?: string;
  deliveryMethod?: string;
  temsOfDelivery?: string;
  shipmentType?: string;
  carrierName?: string;
  termsOfPayment?: string;
  employee?: string;
  orderPriority?: number;
  customerPriority?: number;
  district?: string;
  contactName?: string;
  orderTotal?: number;
  customerType?: string;
  customerGrp1?: string;
  customerGrp2?: string;
  customerGrp3?: string;
  isRemainderYesNo?: boolean;
  createRemainderYesNo?: boolean;
  emailAddress?: string;
  orderDeliveryYear?: number;
  orderDeliveryMonth?: number;
  orderDeliveryDay?: number;
  orderDeliveryWeek?: number;
  orderFreeField1?: string;
  orderFreeField2?: string;
  orderFreeField3?: string;
  orderFreeField4?: string;
  orderFreeField5?: string;
  orderFreeField6?: string;
  orderFreeField7?: string;
  orderFreeField8?: string;
  orderFreeField9?: string;
  orderFreeField10?: string;
  orderFreeField11?: string;
  orderFreeField12?: string;
  orderFreeField13?: string;
  orderFreeField14?: string;
  orderFreeField15?: string;
  orderFreeField16?: string;
  customerDeliveryDay?: string;
  telephone?: string;
  mobTelephone?: string;
  tripID?: number;
  districtNo?: number;
  eventCustomerRef1?: string;
  eventCustomerRef2?: string;
  eventCustomerRef3?: string;
  emailNotificationAddress?: string;
  smsNotificationAddress?: string;
  intEmailNotificationAddress?: string;
  intSMSNotificationAddress?: string;
  distributionYesNo?: boolean;
  deliveryAlias?: string;
  filterGroupID?: string;
  pListFreeField1?: string;
  pListFreeField2?: string;
  pListFreeField3?: string;
  shipmentID?: number;
  clientID?: string;
  loadingName?: string;
  loadingAddress1?: string;
  loadingZipCode?: string;
  loadingCity?: string;
  loadingCountry?: string;
  dropPointID?: string;
  warehouse?: string;
  arrivalDate?: string;
  deliveryMethodNo?: number;
  consignmentSWProductNo?: string;
  formNoPackingslip?: number;
  formNoInvoice?: number;
  updatedBy?: string;
  lastUpdate?: string;
  createdBy?: string;
  created?: string;
  statusText: string;
}

export interface OrderLineDto {
  id: number;
  companyNo: string;
  orderNo: number;
  lineNo: number;
  lineNoERP?: number;
  lineStatus: number;
  pListID?: number;
  itemNo: string;
  itemBarCode?: string;
  description1?: string;
  itemGroup1?: string;
  itemGroup2?: string;
  itemGroup3?: string;
  quantity?: number;
  quantityDelivered?: number;
  quantityPicked?: number;
  itemUnitCode?: string;
  itemUnitTxt?: string;
  price?: number;
  discount?: number;
  deliveryDate?: string;
  serialNoItemYesNo?: boolean;
  stdLocationName?: string;
  pickZone?: string;
  warehouse?: string;
  batchID?: string;
  expirationDate?: string;
  weight?: number;
  height?: number;
  length?: number;
  width?: number;
  volum?: number;
  itemPictureName?: string;
  quantityReserved?: number;
  lineStatus2?: number;
  startDateTime?: string;
  stopDateTime?: string;
  quantityAvailable?: number;
  operatorTxt?: string;
  approveQuantityDeviation?: boolean;
  changeQuantityOnDeviation?: boolean;
  pListBatchYesNo?: boolean;
  packageNo?: number;
  visiblePackageNo?: number;
  useSTAND005?: boolean;
  orderLineFreeField1?: string;
  orderLineFreeField2?: string;
  orderLineFreeField3?: string;
  orderLineFreeField4?: string;
  orderLineFreeField5?: string;
  orderLineFreeField6?: string;
  orderLineFreeField7?: string;
  orderLineFreeField8?: string;
  orderLineFreeField9?: string;
  orderLineFreeField10?: string;
  isDisplayPallet?: boolean;
  qtyOnPallet?: number;
  printSTAND005?: boolean;
  itemTemperatureInfo?: string;
  stackingWeight?: number;
  memo1?: string;
  serverStatus?: number;
  stcZoneID?: string;
  binGrpNo?: number;
  resourceNo?: number;
  quantityGross?: number;
  clientID?: string;
  externalSystemID?: number;
  externalSystemStatus?: number;
  pListIDSplit?: number;
  unCode?: string;
  pickListMishandledByOperator?: boolean;
  buyersItemNo?: string;
  subLineNoERP?: number;
  orderNoERP?: string;
  extraQuantityPickedYesNo?: boolean;
  batchItemYesNo?: boolean;
  pickedBy?: string;
  updatedBy?: string;
  lastUpdate?: string;
  createdBy?: string;
  created?: string;
  statusText: string;
  remainingQuantity?: number;
}

class OrdersService {
  /**
   * Get new orders (OrderStatus = 0 / Ubehandlet) with unassigned order lines (PListID = 0)
   */
  async getNewOrdersWithLines(warehouse?: string): Promise<OrderWithLinesDto[]> {
    const params = new URLSearchParams();
    if (warehouse) params.append('warehouse', warehouse);
    const queryString = params.toString() ? `?${params.toString()}` : '';
    const response = await ApiClient.get(`${API_BASE_URL}/orders/newOrders/with-lines${queryString}`);

    if (!response.ok) {
      throw new Error(`Failed to fetch orders with lines: ${response.statusText}`);
    }

    return await response.json();
  }

  /**
   * Get new/unprocessed orders with lines (OrderStatus = 0 / Ubehandlet)
   * @deprecated Use getNewOrdersWithLines() instead for clarity
   */
  async getOpenOrdersWithLines(): Promise<OrderWithLinesDto[]> {
    return this.getNewOrdersWithLines();
  }

  /**
   * Update an order header (inline edit fields)
   */
  async updateOrder(orderNo: number, request: UpdateOrderRequest): Promise<OrderDto> {
    const response = await ApiClient.put(`${API_BASE_URL}/orders/${orderNo}`, request);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Kunne ikke oppdatere ordre: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  }

  /**
   * Update an order line (inline edit fields)
   */
  async updateOrderLine(orderNo: number, lineNo: number, request: UpdateOrderLineRequest): Promise<OrderLineDto> {
    const response = await ApiClient.put(`${API_BASE_URL}/orders/${orderNo}/lines/${lineNo}`, request);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Kunne ikke oppdatere ordrelinje: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  }

  /**
   * Delete an order and its lines.
   * Only allowed when no lines are bound to a picking list.
   */
  async deleteOrder(id: number): Promise<void> {
    const response = await ApiClient.delete(`${API_BASE_URL}/orders/${id}`);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Kunne ikke slette ordre: ${response.status} ${response.statusText}`);
    }
  }

  /**
   * Delete a single order line.
   * Only allowed when the line is not bound to a picking list.
   */
  async deleteOrderLine(id: number): Promise<void> {
    const response = await ApiClient.delete(`${API_BASE_URL}/orders/lines/${id}`);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Kunne ikke slette ordrelinje: ${response.status} ${response.statusText}`);
    }
  }

  // getOrderStatusText / getOrderLineStatusText fjernet 2026-07-02: feil «Model B»-mapping
  // (Åpen/KlarTilPlukking/…/Fakturert/Kansellert) som motsa StatusCodes (StatusType 1).
  // Bruk StatusBadge / statusPresentation.ts i stedet (enhetlig «kode - tekst» + farge).

  /**
   * Format date for display
   */
  formatDate(dateString?: string): string {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('no-NO');
  }

  /**
   * Format currency for display
   */
  formatCurrency(amount?: number): string {
    if (amount === undefined || amount === null) return '';
    return new Intl.NumberFormat('no-NO', {
      style: 'currency',
      currency: 'NOK',
      minimumFractionDigits: 2
    }).format(amount);
  }

  /**
   * Format quantity for display
   */
  formatQuantity(quantity?: number): string {
    if (quantity === undefined || quantity === null) return '';
    return new Intl.NumberFormat('no-NO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(quantity);
  }
}

export const ordersService = new OrdersService();
